module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/label_small_question.c7ed6.png";